export const defaultStyle = {
  container:"px-[100px]",
  brandLabelWrapper: "brandLabelWrapper relative mb-70 md:mb-[95px] text-right max-w-xl mx-auto",
  borderBottom:"",
  typeFilter:"text-[21px] md:text-[36px] font-bold tracking-[0.9px] text-purple cursor-pointer pr-[30px] ",
  brandFilterWrapper: "brandFilterWrapper duration-300 block relative",
  brandFiltersList:
    "brandFiltersList bg-[#4f2170] absolute top-[-65px] md:top-[-92px] lg:right-[0px] right-[26px] md:right-[6px] lg:right-[13px] z-50 overflow-hidden cursor-pointer",
  brandFilterRow: "brandFilterRow last:border-t-1 last:border-[#724D8D]",
  filterText: "filterText text-white text-[17px] px-[30px] py-7 tracking-[0.45px] leading-[27px]",
  brandSection: "brandsMainWrapper flex flex-wrap text-center md:pb-70 max-w-xl mx-auto",
  brandWrapper: "brandWrapper w-1/2 md:w-4/12 lg:w-1/4 px-25 md:px-50 mb-45 md:mb-90",
  brandShapePic: "brand-image-wrapper flex flex-col w-full text-center items-center justify-center",
  brandLink: "brandLink relative block",
  brandImg:
    "absolute top-[89%] left-[50%] w-[60%] -translate-x-2/4 -translate-y-2/4 z-8",
  title: "text-32 md:text-[30px] text-black font-bold mt-25 mb-15",
}
